export const COMMUNITY_CONFIG_FEATURE_TITLE = 'Community Configuration'
export const COMMUNITY_CONFIG_FEATURE_DESCRIPTION = 'Manage configuration settings for communities'

// Section Titles
export const DEFAULT_CONFIGURATIONS_TITLE = 'Default Configurations'
export const COMMUNITY_CONFIGURATIONS_TITLE = 'Community Configurations'
export const NEWSLETTER_COUNTS_TITLE = 'Newsletter Counts'

// Success/Error Messages
export const COMMUNITY_CONFIG_SUCCESS_MESSAGE = 'Configuration updated successfully'
export const COMMUNITY_CONFIG_FAILURE_MESSAGE = 'Failed to update configuration'
export const COMMUNITY_CONFIG_DELETE_SUCCESS_MESSAGE = 'Configuration deleted successfully'
export const COMMUNITY_CONFIG_DELETE_FAILURE_MESSAGE = 'Failed to delete configuration'
export const COMMUNITY_CONFIG_CREATE_SUCCESS_MESSAGE = 'Configuration created successfully'
export const COMMUNITY_CONFIG_CREATE_FAILURE_MESSAGE = 'Failed to create configuration'

export const ADD_CONFIG_MODAL_TITLE = 'Add New Configuration'
export const ADD_CONFIG_BUTTON_TEXT = 'Add Config'
export const SAVE_CONFIG_BUTTON_TEXT = 'Save Configuration'
export const CANCEL_BUTTON_TEXT = 'Cancel'

// Grid Column Headers
export const COLUMN_KEY = 'Key'
export const COLUMN_VALUE = 'Value'
export const COLUMN_ACTION = 'Action'

// Action Button Texts
export const EDIT_BUTTON_TEXT = 'Edit'
export const SAVE_BUTTON_TEXT = 'Save'
export const DELETE_BUTTON_TEXT = 'Delete'

// Confirmation Messages
export const CONFIRM_DELETE_TITLE = 'Delete Configuration'
export const CONFIRM_DELETE_MESSAGE = 'Are you sure you want to delete this configuration? This action cannot be undone.'

export const CONFIG_KEY_PLACEHOLDER = 'Enter configuration key'
export const CONFIG_VALUE_PLACEHOLDER = 'Enter configuration value'
export const CONFIG_DESCRIPTION_PLACEHOLDER = 'Enter optional description'


export const NO_CONFIGURATIONS_MESSAGE = 'No configurations found for this community'
export const NO_DEFAULT_CONFIGURATIONS_MESSAGE = 'No default configurations found'
export const NO_COMMUNITY_CONFIGURATIONS_MESSAGE = 'No community-specific configurations found'
export const NO_NEWSLETTER_CATEGORIES_MESSAGE = 'No newsletter categories found'
export const LOADING_CONFIGURATIONS_MESSAGE = 'Loading configurations...'
export const LOADING_NEWSLETTER_CATEGORIES_MESSAGE = 'Loading newsletter categories...'

// Configuration Source Values
export const CONFIG_SOURCE_DEFAULT = 'default'
export const CONFIG_SOURCE_SPECIFIC = 'specific'

export const CONFIG_TYPE_DROPDOWN_LABEL = 'Configuration Type'
export const CONFIG_TYPE_COMMUNITY = 'Community'
export const CONFIG_TYPE_DEFAULT = 'Default'

export const FORM_FIELDS = {
  CONFIG_KEY: 'config_key',
  CONFIG_VALUE: 'config_value',
  DESCRIPTION: 'description',
  COMMUNITY_ID: 'community_id',
}

export enum ConfigurationAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

// Newsletter Counts Column Headers
export const NEWSLETTER_COLUMN_NAME = 'Name'
export const NEWSLETTER_COLUMN_MAXIMUM = 'Maximum'
export const NEWSLETTER_COLUMN_MINIMUM = 'Minimum'
export const NEWSLETTER_COLUMN_MAX_PREFERRED = 'Max Preferred'
export const NEWSLETTER_COLUMN_MAX_LEAD = 'Max Lead'
export const NEWSLETTER_COLUMN_MAX_PER_SOURCE = 'Max Per Source'

// Newsletter Counts Success/Error Messages
export const NEWSLETTER_COUNT_SUCCESS_MESSAGE = 'Newsletter count updated successfully'
export const NEWSLETTER_COUNT_FAILURE_MESSAGE = 'Failed to update newsletter count'